import { FC, useEffect } from 'react';
import { FooterContainer } from '../modules/footer/footer.container';
import { JourneysContainer } from '../modules/journeys/journeys.container';

export const Journeys: FC = () => {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.scrollY !== 0) {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <>
      <JourneysContainer />
      <FooterContainer />
    </>
  );
};
